export default __webpack_public_path__ + "static/media/tweet.32aacd3b.svg";